// © 2015-2021 WDNA - All Rights Reserved

import _ from 'lodash';
import * as React from 'react';

import { config } from '../../../config/config';

const formRef: React.RefObject<HTMLFormElement> = React.createRef<HTMLFormElement>();

/**
 * Function to submit wiki formulary
 *
 * @param e form event with the submit action
 */
function goWiki(e: React.FormEvent): void {
  e.preventDefault();
  formRef.current?.submit();
}

/**
 * Component to generate the user menu
 *
 * @returns react node with the user menu element
 */
export default function UserMenu(): JSX.Element {
  const { wiki } = config;

  return (
    <ul id="mobile-profile-img" className="header-dropdown-list hidden-xs padding-5">
      <li className="">
        <a href="#/" className="dropdown-toggle no-margin userdropdown" data-toggle="dropdown">
          <i className="wdna-ico-icon-user" />
        </a>
        <ul className="dropdown-menu pull-right">
          <div>
            <li>
              <a href="#/settings" className="padding-10 padding-top-0 padding-bottom-0">
                <i className="wdna-ico-icon-config" />
                Your settings
              </a>
            </li>
            <li className="divider" />
            <li>
              <a href="#!" className="padding-10 padding-top-0 padding-bottom-0" onClick={goWiki}>
                <i className="wdna-ico-icon-search" />
                Help
              </a>
            </li>
            <li className="divider" />
          </div>
          <li>
            <a href="#/logout" className="padding-10 padding-top-0 padding-bottom-0">
              <i className="wdna-ico-icon-logout" />
              Logout
            </a>
          </li>
        </ul>
      </li>
      <form ref={formRef} method="post" encType="multipart/form-data" target="_blank" action={wiki?.url.toString()}>
        <input type="hidden" name="id" value="start" />
        <input type="hidden" name="do" value="login" />
        <input type="hidden" name="u" value={wiki?.user} />
        <input type="hidden" name="p" value={wiki?.pass} />
      </form>
    </ul>
  );
}
